// syncObjectCycle.js
var SyncObjectCycle = pc.createScript('syncObjectCycle');

// initialize code called once per entity
SyncObjectCycle.prototype.initialize = function() {
    this.app.on('reTrigger', this.synCycle, this);
    this.objects = new Array(0);
    this.objects = this.entity.findByTag('syncObj');
    //console.log('objs: ' + this.objects.length);
};

SyncObjectCycle.prototype.synCycle = function() {
    for(var i = 0; i < this.objects.length; i++){
        this.objects[i].enabled = false;
    }
    var rnd = Math.floor(Math.random()*this.objects.length);
    this.objects[rnd].enabled = true;
};

// update code called every frame
SyncObjectCycle.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// SyncObjectCycle.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

